import authentication from '../views/authentication/store'
import dashboard from '../views/dashboard/store'

export default {
    authentication,
    dashboard
}